import MissingReportedHoursHomePage from '../components/working-hours/missing-reported-hours.home-page';
import React from 'react';

const MissingReportsHoursTab = () => {
  return (
    <div>
      <div style={{ flex: '0.5' }}>
        <MissingReportedHoursHomePage />
      </div>
    </div>
  );
};

export default MissingReportsHoursTab;
